import { createFileRoute } from '@tanstack/react-router';
import { OnlinePlayPage } from '@/pages/online-play.page';

export const Route = createFileRoute('/room/$code')({
  component: OnlinePlayPage,
});
